export enum ZoneType {
  ROTATION = "ROTATION",
  ZMRC = "ZMRC",
  VER = "VER"
}
